<template>
    <div class="recommend">
        <scroll ref="scroll" class="recommend-content" :data="columnStore" :pullup="pullup" :beforeScroll="beforeScroll" @scrollToEnd="columnListMore">
            <div>
                <div class='column_main'>
                    <ul>
                        <li v-for="item,index in columnStore" :key="index" @click="hanleClickToPage(`/lives/detail/id/${item.o_id}/jump_type/1.html`)">
                            <h3>{{item.title}}</h3>
                            <p class='action' v-html="item.content "></p>
                            <div class="ub column-user align-items">
                                <div class="ub-f1 align-items">
                                    <img :src="item.image" alt="" />
                                    <span class='autor'>{{item.source}}&nbsp;&nbsp;{{item.rec_time_desc}}</span>
                                </div>
                                <div class="nowrap">{{item.view_num > 10000 ? item.view_num/10000 + '万' : item.view_num}}次阅读</div>
                            </div>
                        </li>
                    </ul>
                    <loading class="loadbox" style="padding: 12px 0;" loadType="small" :title="''" v-if="listLoading"></loading>
                    <read-more v-if="!hasMore&&!listLoading"></read-more>
                </div>
            </div>
        </scroll>
    </div>
</template>
<script>
import Scroll from '@/base/scroll'
import HomeApi from '@/api/column/';
import readMore from '@/components/readMore/';

export default {
    name: 'Column',
    components: {
        Scroll,
        readMore
    },
    data() {
        return {
            pullup: true,
            beforeScroll: true,
            hasMore: false,
            listLoading: true,
            columnStore: [{}, {}, {}, {}, {}, {}, {}, {}],
            page: 1,
            randomStr: Math.random().toString(36).slice(-4)

        };
    },
    created() {
        this.getColumnList()
    },

    methods: {
        columnListMore() {
            if (!this.hasMore) return
            this.page++
            this.getColumnList()
        },
        // async init() {
        //     let data = await HomeApi.getColumnList(this.page)
        //     if (this.page === 2) {
        //         this.columnStore.list.push(...data)
        //         this.setState({
        //             bool: true
        //         })
        //     } else if (this.page === 1) {
        //         this.columnStore.list = data
        //         // this.scroll.finishPullDown()
        //         if (data) {
        //             successToast()
        //         } else if (this.page > 2 && data) {
        //             failToast()
        //         }
        //     } else {
        //         this.scroll.finishPullUp()
        //         showToastNoMask()
        //     }
        //     this.scroll.refresh()
        // },
        async getColumnList() {
            let data = await HomeApi.getColumnList(this.page)
			if (this.page === 1) {
			    this.columnStore = data
			}else{
                this.columnStore = this.columnStore.concat(data)
			}

            if (this.page < 2) {
                this.hasMore = true
            } else {
                this.hasMore = false
                this.listLoading = false
            }
        }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.border-1px(@color: #ccc, @radius: 0PX, @style: solid) {
    position: relative;

    &::after {
        content: "";
        pointer-events: none;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        border-bottom: 1PX @style @color;
        border-radius: @radius;
        box-sizing: border-box;
        width: 100%;
        height: 100%;

        @media (min-resolution: 2dppx) {
            width: 200%;
            height: 200%;
            border-radius: @radius * 2;
            transform: scale(.5);
        }

        @media (min-resolution: 3dppx) {
            width: 300%;
            height: 300%;
            border-radius: @radius * 3;
            transform: scale(.333);
        }
    }
}

.recommend {
    position: fixed;
    overflow: auto;
    top: 48px;
    width: 100%;
    padding-bottom: 50px;
    bottom: 0;
    background-color: #F0F0F0;
}

.recommend-content {
    height: 100%;
    overflow: hidden;
}

.column_main {
    padding-top: 10px;
    background-color: #F0F0F0;
    // width: 100%;
    // height: 100%;
    // margin-top: 10px;

    ul {
        padding: 0px 14px 0 14px;
        // width: 100%;
        background-color: #FFFFFF;

        li {
            width: 100%;
            padding-top: 14px;
            .border-1px(#E8E8E8);

            h3 {
                margin-bottom: 14px;
                font-size: 16px;
                font-family: PingFangSC-Medium;
                font-weight: bold;
                text-align: left;
                color: #222222;

                max-height: 48px;
                min-height: 36px;
                overflow: hidden;
                line-height: 24px;
                // text-overflow:ellipsis;
                //最多两行显示
                display: -webkit-box;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                // padding-top: 10px;
            }

            p {
                width: 100%;
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: left;
                font-size: 13px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: #636363;
            }

            .nowrap {
                text-align: right;
                font-size: 13px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: #636363;
            }

            .action {
                max-height: 37px;
                min-height: 30px;
                //最多两行显示
                display: -webkit-box;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }

            .column-user {
                padding: 10px;
                font-size: 12px;
                color: #939393;
                font-family: PingFangSC-Regular;
                font-weight: 400;

                img {
                    width: 30px;
                    height: 30px;
                    border-radius: 100%;
                    vertical-align: middle;
                }

                .autor {
                    height: 15px;
                    width: 254px !important;
                    margin-left: 12px;
                    color: #939393;
                    text-align: left;
                    vertical-align: middle;
                }


            }
        }
    }
}
</style>